import { render, staticRenderFns } from "./BuddyFaq.vue?vue&type=template&id=4d37f69e"
import script from "./BuddyFaq.vue?vue&type=script&lang=ts"
export * from "./BuddyFaq.vue?vue&type=script&lang=ts"
import style0 from "./BuddyFaq.vue?vue&type=style&index=0&id=4d37f69e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports